module.exports = __webpack_public_path__ + "img/banner-title.33dc41e2.png";